import {useMutation} from '@tanstack/vue-query';
import { getApi } from '../api';

export default () => useMutation({
    mutationFn: ({ dialogId, messageId } : { dialogId: number, messageId: string}) => {
        const { api, baseURL } = getApi();
        return api.delete(`/api/v2/dialogs/${dialogId}/messages/${messageId}/feedback`, { baseURL, useOriginalToken: true }).then(res => res.data)
    },
}) 